import { Injectable, computed, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class QuizStateService {
  private quizName = signal('');

  public readonly quizNameValue = computed(() => this.quizName());

  setQuizName(name: string): void {
    this.quizName.set(name);
  }
}
